/** @jsxImportSource @emotion/react */
import {
  Display,
  Heading1,
  Space,
  Visible,
} from '@gousto-internal/citrus-react'
import { Breadcrumbs } from '../Breadcrumbs'
import type { Category, Section } from '../../types/entities'
import { Hero } from '../Hero/Hero'

type HeroProps = {
  categories?: Category[],
  currentCategoryId?: string,
  sections?: Section[],
  currentSectionId?: string,
}

const HeroWithBreadcrumbs = ({
  categories,
  currentCategoryId,
  sections,
  currentSectionId,
}: HeroProps) => {
  const message = 'Help Centre'

  return (
    <>
      <Hero>
        <Visible display={[Display.None, Display.Block]}>
          <Heading1 size={[5, 6, 7]}>
            {message}
          </Heading1>
        </Visible>
        <Breadcrumbs
          categories={categories}
          currentCategoryId={currentCategoryId}
          sections={sections}
          currentSectionId={currentSectionId}
        />
      </Hero>
      <Space size={[6, 12]} />
    </>
  )
}

export { HeroWithBreadcrumbs }
